// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"74":"About","109":"Adventures","268":"Home","315":"Contacts","711":"Publisher"}[chunkId] + "." + {"74":"baf33e07","109":"1c4fe6ff","268":"8ac49e1f","315":"dfa2929f","711":"04256b57"}[chunkId] + ".css";
};